import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ViewChild, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from 'src/commons/modals';

@Component({
    selector: 'project-task-modal',
    templateUrl: './project-task-details.component.html',
    styleUrls: ['./project-task-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectTaskDetailsComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    @Input() projectTaskData: any;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    displayedColumns = ['select','company', 'organization', 'account', 'project', 'task'];
    dataSource: MatTableDataSource<any>;

    selection = new SelectionModel<any>(true, []);

    public confirm: any;
    selectedProjectTaskData: any[] = [];

    constructor(
        private _dataService: LGEDataService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ProjectTaskDetailsComponent>,
        private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.message = data.message;
        this.title = data.title;
        this.projectTaskData = data.projectTaskData;
    }

    ngOnInit() {
        this.createForms();
        setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.projectTaskData);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
        this.selectedProjectTaskData = this.projectTaskData.filter((projectTask) => projectTask.isActive);
    }

    isAllSelected() {
        const numSelected = this.selectedProjectTaskData.length;
        const numRows = this.dataSource && this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(event) {
        // console.log(event);
        this.selection.clear();
        this.dataSource.data.forEach(row => row.isActive = event.checked);
        this.selectedProjectTaskData = event.checked ? this.dataSource.data : [];
    }
    projectTaskChecked(row) {
        this.selection.toggle(row);

        if (this.selectedProjectTaskData.find(projectTask => row.projectTaskId === projectTask.projectTaskId) && !row.isActive) {
            const index = this.selectedProjectTaskData.findIndex(projectTask => row.projectTaskId === projectTask.projectTaskId);
            this.selectedProjectTaskData.splice(index, 1);
        } else {
            this.selectedProjectTaskData.push(row);
        }
        // console.log(row);
        // console.log(this.selectedProjectTaskData);
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    createForms(): void {

    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    onSave() {
        this.showConfirm('Are you sure you want to save?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.dialogRef.close(this.selectedProjectTaskData);
            }
        });
    }

    onCancel() {
        this.dialogRef.close();
    }

    ngOnDestroy() {

    }
}
